import type { FilterCategory } from "@/types/filterCategory";
import * as contentType from "@/globalConsts/searchFunnelContentTypes";

export const filterNameTranslation: { [index: string]: FilterCategory } = {
  travelPrice: { title: "price", contentType: contentType.PRICE },
  2: { title: "travel_type", contentType: contentType.TRIP_TYPE },
  3: { title: "travel_style", contentType: contentType.THEME },
  4: { title: "travel_feature", contentType: contentType.FEATURE },
  country: { title: "countries", contentType: contentType.COUNTRY },
  region: { title: "regions", contentType: contentType.REGION },
  highlight: {
    title: "places_sights",
    contentType: contentType.HIGHLIGHTS,
  },
  organizer: { title: "organizer", contentType: contentType.ORGANIZER }, // todo: NSDJW-6200: has to be removed after release
  travelNumber: { title: "trip_code", contentType: contentType.TRIP_ID },
};
